var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTriggerAlert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2961_1294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0826 2.62329L18.2776 15.085C18.3874 15.275 18.4451 15.4905 18.4451 15.7099C18.4451 15.9294 18.3874 16.1449 18.2777 16.3349C18.1679 16.525 18.0102 16.6828 17.8201 16.7925C17.6301 16.9022 17.4146 16.96 17.1951 16.96H2.80514C2.58573 16.96 2.37017 16.9022 2.18016 16.7925C1.99014 16.6828 1.83234 16.525 1.72264 16.3349C1.61293 16.1449 1.55517 15.9294 1.55518 15.7099C1.55518 15.4905 1.61293 15.275 1.72264 15.085L8.91764 2.62329C9.39848 1.78996 10.601 1.78996 11.0826 2.62329ZM10.0001 12.5C9.77913 12.5 9.56717 12.5878 9.41089 12.744C9.25461 12.9003 9.16681 13.1123 9.16681 13.3333C9.16681 13.5543 9.25461 13.7663 9.41089 13.9225C9.56717 14.0788 9.77913 14.1666 10.0001 14.1666C10.2212 14.1666 10.4331 14.0788 10.5894 13.9225C10.7457 13.7663 10.8335 13.5543 10.8335 13.3333C10.8335 13.1123 10.7457 12.9003 10.5894 12.744C10.4331 12.5878 10.2212 12.5 10.0001 12.5ZM10.0001 6.66662C9.79603 6.66665 9.59903 6.74159 9.4465 6.87722C9.29397 7.01285 9.19653 7.19975 9.17264 7.40246L9.16681 7.49996V10.8333C9.16705 11.0457 9.24838 11.25 9.39418 11.4044C9.53999 11.5589 9.73927 11.6518 9.95131 11.6643C10.1633 11.6767 10.3721 11.6077 10.535 11.4714C10.6979 11.3351 10.8026 11.1417 10.8276 10.9308L10.8335 10.8333V7.49996C10.8335 7.27894 10.7457 7.06698 10.5894 6.9107C10.4331 6.75442 10.2212 6.66662 10.0001 6.66662Z",
    fill: "#FF8F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2961_1294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTriggerAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/triggerAlert.7f69bca54ca30bd6c19ef0bb4ac52745.svg";